// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const ChevronLeft = React.forwardRef(function ChevronLeft(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></SvgIcon>;
});
export default ChevronLeft;
